import { Component, effect, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { environment } from "src/environments/environment";

import { QboAccountsModalComponent } from "../dashboard/main/accountant/qbo-accounts-modal/qbo-accounts-modal.component";
import { QuickbooksIntegrationService } from "../dashboard/quickbooks-integration.service";
import { Company } from "../dashboard/shared-data.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AccountantService } from "../dashboard/main/accountant/accountant.service";
import { QuickBooksData } from "../dashboard/main/accountant/quickbooks-integration.component";
import { TypeaheadMatch, TypeaheadModule } from "ngx-bootstrap/typeahead";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DashboardStore } from "../dashboard/dashboard.store";
import { Subject } from "rxjs";
import { HotToastService } from "@ngneat/hot-toast";
import { fromStorage } from "../from-storage.function";

@Component({
  selector: "app-add-client-wizard",
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TypeaheadModule],
  templateUrl: "./add-client-wizard.component.html",
  styleUrls: [
    "./add-client-wizard.component.scss",
    "../dashboard/main/accountant/qbo-accounts-modal/qbo-accounts-modal.component.scss",
  ],
})
export class AddClientWizardComponent {
  companyAccounts = [];
  companiesAccounts: any = {};
  availableQboAccounts: any = [];
  selectedAccount: any = {};
  loading: boolean = false;
  accountName: string = "";

  quickbooksData: QuickBooksData[] = [];

  public onClose: Subject<any>;

  step: number = 1;

  company: Company;
  companyName: string;

  client: any = {
    name: "",
    email: "",
  };

  newCompanyConnectionStatus = fromStorage<boolean | null>(
    "newCompanyConnectionStatus",
  );

  constructor(
    private toastr: HotToastService,
    private qbServices: QuickbooksIntegrationService,
    private accountantService: AccountantService,
    public bsModalRef: BsModalRef,
    private dashboardStore: DashboardStore,
  ) {
    effect(() => {
      console.log(
        "Syncing storage on wizard",
        this.newCompanyConnectionStatus(),
      );

      if (this.newCompanyConnectionStatus() == true) {
        this.getConnectedWorkspaces();
        this.loadAccounts();
        this.toastr.success(`Authenticated in QuickBooks.`);
        this.step = 3;
      } else if (this.newCompanyConnectionStatus() == false) {
        let errorMessage = `Couldn't authenticate in QuickBooks.`;
        this.toastr.error(errorMessage);
        console.error(errorMessage);
      }
    });
  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.newCompanyConnectionStatus.set(null);
  }

  loadAccounts() {
    this.loading = true;
    this.qbServices
      .getAccountsByCompanyId(this.company.id)
      .subscribe((res: any) => {
        this.availableQboAccounts = res;
        this.loading = false;
      });

    this.qbServices.getCompanyAccounts(this.company.id).then((res) => {
      this.companyAccounts = res;
    });
  }

  launchAuthenticationForm(workspaceId: number) {
    this.loading = true;
    let isListenerExhausted = false;

    const path = `${environment.apiUrl}/integration/quickbooks/auth?integrate=${workspaceId}`;

    let parameters = "location=1,width=800,height=650";
    parameters +=
      ",left=" + (screen.width - 800) / 2 + ",top=" + (screen.height - 650) / 2;

    window.open(path, "connectPopup", parameters);
  }

  createCompany(): void {
    this.loading = true;

    this.accountantService
      .invite_client(null, null, this.companyName, 2, null, 2)
      .then(
        (res: any) => {
          this.toastr.success(res.message);
          if (res.company) {
            this.company = res.company;
            this.dashboardStore.addClient(this.company);

            this.loading = false;
            this.step = 2;
          }
        },
        (err) => {
          console.log("error", err);
          this.toastr.error(err.error.message);
          this.loading = false;
        },
      );
    // }
  }

  inviteClient(): void {
    // this.inviteFormSubmitAttempt = true;
    // if (this.inviteForm.valid) {
    // this.dashboardService.show_loading.next(true);
    this.loading = true;
    this.accountantService
      .invite_client(
        this.client.name,
        this.client.email,
        this.companyName,
        2,
        this.company.id,
        2,
      )
      .then(
        (res: any) => {
          this.loading = false;
          this.toastr.success(res.message);
          this.closeModal();
        },
        (err) => {
          this.toastr.error(err.error.message);
          this.loading = false;
        },
      );
    // }
  }

  getConnectedWorkspaces() {
    this.loading = true;

    this.qbServices.getCompaniesAccounts().then((res) => {
      console.log("companiesAccounts", res);
      this.companiesAccounts = res;
    });

    this.qbServices.getConnectedWorkspaces().then(
      (res) => this.handleConnectedWorkspacesResponse(res),
      (err) => this.handleError(`Couldn't load connected workspaces.`, err),
    );
  }

  private handleConnectedWorkspacesResponse(res: QuickBooksData[]) {
    this.quickbooksData = [];
    if (res !== undefined && res.length > 0) {
      res.forEach((entry: QuickBooksData) => {
        if (entry.company_name) {
          this.quickbooksData.push({
            uuid: entry.uuid,
            workspace_id: entry.workspace_id,
            workspace_name: entry.workspace_name,
            company_name: entry.company_name,
            class_tracking: entry.class_tracking,
            is_integrated: true,
          });
        }
      });
      // this.toggleIntegrationStep(STATE_INTEGRATED_WORKSPACES);
    } else {
      // this.toggleIntegrationStep(STATE_NO_INTEGRATED_WORKSPACES);
    }
    this.loading = false;
  }

  private handleError(message: string, err: any) {
    this.loading = false;
    this.toastr.error(message);
    console.error(err);
  }

  selectAccount(event: TypeaheadMatch) {
    this.selectedAccount = event.item;
  }

  deleteCompanyAccountLink(linkUuid) {
    this.qbServices.deleteCompanyAccountLink(linkUuid).then((res) => {
      this.companyAccounts = this.companyAccounts.filter(
        (link) => link.uuid !== linkUuid,
      );
    });
  }

  addAccountToCompany() {
    this.qbServices
      .addAccountToCompany(this.company.id, {
        accountId: this.selectedAccount.id,
        accountName: this.selectedAccount.name,
        accountPath: this.selectedAccount.path,
      })
      .then((res) => {
        this.companyAccounts.push(res);
        this.selectedAccount = {};
        this.accountName = "";
      });
  }

  canInviteClient() {
    return (
      this.client.name &&
      this.client.email &&
      this.client.email.includes("@") &&
      this.client.email.includes(".") &&
      this.client.name.length > 0 &&
      this.client.email.length > 0
    );
  }

  closeModal() {
    this.onClose.next(this.company);
    this.bsModalRef.hide();
  }
}
